import { helper } from '@ember/component/helper';
import {
  getSqlDatabaseDocumentationUrl,
  getSqlDatabaseImageSrc,
  getSqlDatabaseName,
  getSqlStorageType,
  SqlImportDatabase,
} from 'cio/utils/sql-import';

export function sqlImportDatabaseInfo([detail, type]: [
  'imageSrc' | 'name' | 'store' | 'documentationUrl',
  SqlImportDatabase,
]) {
  return {
    imageSrc: getSqlDatabaseImageSrc(type),
    name: getSqlDatabaseName(type),
    store: getSqlStorageType(type),
    documentationUrl: getSqlDatabaseDocumentationUrl(type),
  }[detail];
}

export default helper(sqlImportDatabaseInfo);
